<template>
    <div class="container">
        <!-- <div id="downloadButton">sssssss</div> -->
        <img src="../assets/back.jpg" class="longImg" alt="">
        <div class="codeContainer">
            <div :class="isPc ? 'code' : 'smallcode'">
                <img src="../assets/code.png" :class="isPc ? 'codeIco' : 'smallcodeIco'" alt="">
            </div>
            <div class="choseContainer">
                <img src="../assets/Apple@2x.png" @click="goAppsotre" :class="isPc ? 'choseIco' : 'smallchoseIco'" alt="">
                <img src="../assets/Android@2x.png" @click="downApk" :class="isPc ? 'choseIco' : 'smallchoseIco'" alt="">
            </div>
        </div>
        <div class="downContainer" v-if="!isPc">
            <div class="logoContainer">
                <img src="../assets/logo.png" class="logoIco" alt="">
                <div class="titleContainer">
                   <div class="title">对看</div> 
                   <div class="subtitle">一眼定情，甜蜜随行</div> 
                   <div class="subtitle">版本：{{versonInfo.t_version}}</div> 
                </div>
            </div>
            <div class="btn" @click="downApk">立即下载</div>
        </div>
    </div>
</template>



<script>
import { serverApi } from "@/server/index";
export default {
    name: 'home',
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            isPc: true,
            versonInfo:{}
        }
    },
    created() {
        let that = this
        if (this.isMobile()) {
            that.isPc = false
            console.log('移动端');
        } else {
            that.isPc = true
            console.log('PC端');
        }
        this.getVerson()

    },
    methods: {
        isMobile() {
            // 判断是否为移动设备
            return (
                typeof window.orientation !== "undefined" || // 判断是否存在window.orientation属性，此属性在移动设备上一般存在
                navigator.userAgent.indexOf('IEMobile') !== -1 || // 判断是否为Windows Phone
                navigator.userAgent.indexOf('iPhone') !== -1 || // 判断是否为iPhone
                navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile') !== -1 || // 判断是否为Android手机
                navigator.userAgent.indexOf('BlackBerry') !== -1 || // 判断是否为BlackBerry
                navigator.userAgent.indexOf('Opera Mini') !== -1 // 判断是否为Opera Mini浏览器
            );
        },
        async downApk() {
            const { data } = await serverApi.requestApi("get", "/app/open/getNewVersion").then();
            window.location.href=data.data.t_download_url

        },
        async getVerson(){
            const { data } = await serverApi.requestApi("get", "/app/open/getNewVersion").then();
            this.versonInfo=data.data
        },
        goAppsotre(){
            window.location.href='itms-apps://itunes.apple.com/cn/app/id${appleId}?mt=8'
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
    width: 100%;
}

.longImg {
    width: 100%;
}

.container {
   position: relative;
}

.codeContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    right: 10%;
    top: 10%;
}

.code {
    width: 148px;
    height: 148px;
    background: #FFFFFF;
    border-radius: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
}

.smallcode {
    width: 74px;
    height: 74px;
    background: #FFFFFF;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
}

.smallcodeIco {
    width: 36px;
    height: 36px;
}

.codeIco {
    width: 93px;
    height: 93px;
}

.choseContainer {
    margin-bottom: 60px;

}

.choseIco {
    width: 126px;
    height: 36px;
    margin-left: 30px;
}

.smallchoseIco {
    width: 42px;
    height: 12px;
    margin-left: 6px;
}
.downContainer{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 20px;
    height: 88px;
    margin: 0 16px;
    padding:0 16px;
    background: #FFFFFF;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.logoContainer{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.logoIco{
    width: 56px;
    height: 56px;
    border-radius: 10px;
    margin-right: 8px;
}
.titleContainer{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 56px;
}
.title{
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    /* text-align: left; */
}
.subtitle{
    font-size: 12px;
    color: #000000;
}
.btn{
    width: 84px;
    height: 44px;
    border-radius: 20px;
    background: #702EFF;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue